import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = BACKEND_URL ? `${BACKEND_URL.replace(/\/$/, '')}/api` : '/api';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [lastLoginError, setLastLoginError] = useState(null); // 'invalid' | 'network' | null

  useEffect(() => {
    // URL parametresinde pin veya logout varsa oturumu sıfırla (kolay test ve erişim için)
    const params = new URLSearchParams(window.location.search);
    if (params.get('pin') === 'true' || params.get('logout') === 'true' || params.has('login')) {
      localStorage.removeItem('site_authenticated');
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }

    // localStorage'dan oturum kontrolü
    const auth = localStorage.getItem('site_authenticated');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);

  const verifyPassword = async (password) => {
    try {
      setLastLoginError(null);
      const response = await axios.post(`${API}/verify-password`, {
        password: password
      });
      return Boolean(response.data?.valid);
    } catch (error) {
      console.error('Şifre kontrolü hatası:', error);
      setLastLoginError('network');
      return false;
    }
  };

  const completeLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('site_authenticated', 'true');
  };

  const login = async (password) => {
    try {
      setLastLoginError(null);
      const isValid = await verifyPassword(password);
      if (isValid) {
        completeLogin();
        return true;
      }
      setLastLoginError('invalid');
      return false;
    } catch (error) {
      console.error('Şifre kontrolü hatası:', error);
      setLastLoginError('network');
      return false;
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('site_authenticated');
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      isLoading,
      login,
      verifyPassword,
      completeLogin,
      logout,
      lastLoginError
    }}>
      {children}
    </AuthContext.Provider>
  );
};
